const MAX_ERROR_PERCENTAGE = 30;

export function getTextLengthRange(text: string) {
    const length = text.length;
    const minLength = Math.floor(length - length * (MAX_ERROR_PERCENTAGE / 100));
    const maxLength = Math.ceil(length + length * (MAX_ERROR_PERCENTAGE / 100));

    return {
        minLength,
        maxLength,
    };
}
